import React from "react";
import { default as MuiToogleButtonGroup } from "@mui/material/ToggleButtonGroup";

function ToogleButtonGroup(props) {
  return <MuiToogleButtonGroup {...props} />;
}

export default ToogleButtonGroup;
